import { Input, Select } from "../../components/ui/Input";

const STATUSES = [
	{ value: "", label: "All statuses" },
	{ value: "ACTIVE", label: "Active" },
	{ value: "DRAFT", label: "Draft" },
	{ value: "ARCHIVED", label: "Archived" },
];

interface ProductFiltersProps {
	search: string;
	status: string;
	onSearchChange: (value: string) => void;
	onStatusChange: (value: string) => void;
}

export const ProductFilters = ({
	search,
	status,
	onSearchChange,
	onStatusChange,
}: ProductFiltersProps) => (
	<div className="flex flex-col gap-3 sm:flex-row">
		<Input
			type="search"
			value={search}
			placeholder="Search title, handle, or vendor"
			aria-label="Search products"
			onChange={(event) => onSearchChange(event.target.value)}
			className="sm:max-w-xs"
		/>
		<Select
			value={status}
			aria-label="Filter by status"
			onChange={(event) => onStatusChange(event.target.value)}
			className="sm:w-44"
		>
			{STATUSES.map((option) => (
				<option key={option.value} value={option.value}>
					{option.label}
				</option>
			))}
		</Select>
	</div>
);
